import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot, RecoilEnv } from 'recoil';
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// React Fast Refresh re-evaluates atom modules during development HMR cycles.
// Recoil's global key registry persists across those re-evaluations, causing a
// spurious "Duplicate atom key" warning. Disable the check in development only;
// in production there is no HMR so the check is never triggered and this block
// is eliminated by dead-code removal.
if (process.env.NODE_ENV === 'development') {
    RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = false;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Axios interceptor handles retries and 401 refresh; disable TQ retries to avoid doubling up
      retry: false,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <Router>
          <App />
        </Router>
      </RecoilRoot>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
